import script from "./Shapes.vue?vue&type=script&setup=true&lang=js"
export * from "./Shapes.vue?vue&type=script&setup=true&lang=js"

import "./Shapes.vue?vue&type=style&index=0&id=e8033f8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8033f8e"]])

export default __exports__